module.exports = __webpack_public_path__ + "img/root.b884501b.svg";